import { useI18n } from 'vue-i18n';

export type TranslationFunction = (key: string, args?: Record<string, string | number> | (string | number)[]) => string;

export function useTranslation() {
  const { t, te, locale, messages } = useI18n();

  function translate(key: string, args?: Record<string, string | number> | (string | number)[]): string {
    const translationExists = te(key);

    const translatedArgs
      = args && Array.isArray(args)
        ? args.map((arg: string | number): string => translate(arg + ''))
        : args;
    if (translatedArgs) {
      if (Array.isArray(translatedArgs)) {
        return translationExists ? t(key, translatedArgs as string[]) : key;
      }
      return translationExists ? t(key, translatedArgs as Record<string, string | number>) : key;
    }
    return translationExists ? t(key) : key;
  }

  function getLocale() {
    return locale.value;
  }

  function getMessages(key: string) {
    return messages.value[locale.value][key];
  }

  return {
    t: translate,
    locale: getLocale,
    getMessages
  };
}
